module.exports = __webpack_public_path__ + "img/245.7fd81435.jpg";